import React from 'react';
import { OnboardingFlow } from './pages/OnboardingFlow';
export function App() {
  return <OnboardingFlow data-id="element-0" />;
}